import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQS = [
  { q: 'Quanto dura il profumo?', a: 'Le nostre formule rilasciano una fragranza che dura fino a 12 ore nell\'ambiente.' },
  { q: 'I prodotti sono Made in Italy?', a: 'Sì, tutti i prodotti ESSENYA sono formulati e prodotti in Italia.' },
  { q: 'Dove posso usare il lavapavimenti?', a: 'Su tutti i pavimenti lavabili: gres, ceramica, parquet trattato, marmo, laminato.' },
  { q: 'Lo sgrassatore va bene in cucina?', a: 'Sì, è pensato per cucine, piani lavoro, fornelli, cappe e tutte le superfici lavabili.' },
  { q: 'Posso usarlo su tutte le superfici?', a: 'Su quasi tutte. Testa sempre su una piccola area per superfici delicate.' },
  { q: 'Quanto prodotto devo usare?', a: 'Un tappo per lavapavimenti in 5L di acqua. Lo sgrassatore va spruzzato direttamente.' },
  { q: 'Le profumazioni sono intense?', a: 'Sì, ma sono curate per essere persistenti senza essere aggressive.' },
  { q: 'Quanto costa la spedizione?', a: 'Spedizione standard 4,90€. Gratuita sopra i 25€.' },
  { q: 'Dopo quanto arriva l\'ordine?', a: '2-3 giorni lavorativi dalla conferma.' },
  { q: 'Come funzionano resi e rimborsi?', a: 'Hai 14 giorni per restituire il prodotto. Rimborso entro 7 giorni dalla ricezione.' },
  { q: 'I pagamenti sono sicuri?', a: 'Sì, usiamo Stripe con pagamento crittografato.' },
  { q: 'Posso creare un bundle?', a: 'Sì, scegli 3 prodotti e ricevi il 10% di sconto.' },
  { q: "C'è assistenza WhatsApp?", a: 'Sì, ti rispondiamo entro 24 ore dal lunedì al venerdì.' },
  { q: "Posso tracciare l'ordine?", a: 'Sì, ti inviamo il link al tracking via email.' },
  { q: 'Come posso contattarvi?', a: 'Email, WhatsApp o modulo contatti. Vai alla pagina Contatti.' },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <main data-testid="faq-page" className="container-essenya py-16 max-w-3xl">
      <div className="text-eyebrow mb-3">FAQ</div>
      <h1 className="font-display text-4xl md:text-5xl mb-10">Domande frequenti</h1>
      <div className="space-y-2">
        {FAQS.map((f, i) => (
          <div key={i} className="border-b border-essenya-border" data-testid={`faq-item-${i}`}>
            <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full py-5 flex justify-between items-center text-left">
              <span className="font-display text-lg">{f.q}</span>
              <ChevronDown size={20} strokeWidth={1.5} className={`transition-transform ${open === i ? 'rotate-180' : ''}`} />
            </button>
            {open === i && <p className="pb-5 text-essenya-text">{f.a}</p>}
          </div>
        ))}
      </div>
    </main>
  );
}
